var map = {
  "./config/dashpanels": "71185",
  "./modules/admin/dashpanels": "84152",
  "./modules/gndo/dashpanels": "80173",
  "./modules/pagebox/dashpanels": "1313",
  "./modules/restriction/dashpanels": "70611",
  "./modules/stats/dashpanels": "6324",
  "./modules/timeline/dashpanels": "61916"
};


function __rspack_async_context(req) {
  return __rspack_async_context_resolve(req).then(__webpack_require__);
}
function __rspack_async_context_resolve(req) {
  return Promise.all(/* lazy-once context | core */ [__webpack_require__.e("rbush-node_modules_rbush_rbush_min_js"), __webpack_require__.e("vendors-node_modules_date-fns_esm_differenceInYears_index_js-node_modules_date-fns_esm_getDat-803fb0"), __webpack_require__.e("src_modules_serverlog_utils_js-src_tree_rules_js-src_viewer_layouts_js"), __webpack_require__.e("core")]).then(function() {
    if(!__webpack_require__.o(map, req)) {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    }
    return map[req];
  })
}
__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.resolve = __rspack_async_context_resolve;
__rspack_async_context.id = 86945;
module.exports = __rspack_async_context;
